var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsercomponent = function SvgUsercomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 .5C6.1.5.5 6.1.5 13S6.1 25.5 13 25.5 25.5 19.9 25.5 13 19.9.5 13 .5Zm0 3.75A3.745 3.745 0 0 1 16.75 8 3.745 3.745 0 0 1 13 11.75 3.745 3.745 0 0 1 9.25 8 3.745 3.745 0 0 1 13 4.25ZM5.5 17.975a9 9 0 0 0 15 0c-.038-2.488-5.012-3.85-7.5-3.85-2.5 0-7.463 1.363-7.5 3.85Z",
    fill: "current"
  })));
};
export default SvgUsercomponent;